import { CalendarItemCardStep } from './CalendarItemCardStep'

import * as styles from './CalendarItemCardSteps.module.css'

function CalendarItemCardSteps({ steps, onClose }) {
  return (
    <div className={styles.CalendarItemCardSteps}>
      {steps.map(step => (
        <CalendarItemCardStep key={step.id} step={step} onClose={onClose} />
      ))}
    </div>
  )
}

export default CalendarItemCardSteps
